module.exports = __webpack_public_path__ + "img/bedrooms.ee675141.svg";